import { Injectable } from '@angular/core';
import { StartupInfos_ExecutionWorkflows, Model_Workflow, Model_ResponseWorkflow } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { WorkflowService } from './workflow.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';

@Injectable()
export class WorkflowOnlineService extends WorkflowService {

    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
        super();
    }

    doGetStartupInfosAction() {
        return this._httpClient.get<StartupInfos_ExecutionWorkflows>(this._apiService.endPoints.doGetStartupInfosAction_ExecutionWorkflows)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doGetWorkflowByNumAction(_numWorkflow: string) {
        return this._httpClient.get<Model_Workflow>(this._apiService.endPoints.doGetWorkflowByNumAction_ExecutionWorkflows + '/' + _numWorkflow)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
}